import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Button, Alert } from "react-bootstrap";
import AADService from "../funcionesAuth.js";

function ParametrosGenerales() {
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
    const [grupoSeleccionado, setGrupoSeleccionado] = useState("");
    const [opcionesGrupos, setOpcionesGrupos] = useState([]);
    const [parametros, setParametros] = useState([]);
    const [showSuccess, setShowSuccess] = useState(false);
    const originalParametros = useRef([]);
    const [nuevoParametro, setNuevoParametro] = useState({
        idparametrosgenerales: 0,
        grupo: "",
        parametro: "",
        vlrmetrica: "",
        vlrnumericometrica1: "",
        vlrnumericometrica2: "",
        vlrmetrica2: "",
        estado: false,
        disp_numerico1: "",
        disp_varchar1: "",
        disp_varchar2: ""
    });

    useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}general/parametrosGeneralesConsulta/0/`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    )
            .then((res) => res.json())
            .then((data) => {
                if (data.grupos) {
                    setOpcionesGrupos(data.grupos.map(grupo => ({
                        value: grupo,
                        label: grupo
                    })));
                }
            })
            .catch((err) => {
                console.error("Error al obtener grupos:", err);
            });
    }, []);

    const handleChangeGrupo = (e) => {
        const value = e.target.value;
        setGrupoSeleccionado(value);

        if (value) {
      fetch(
        `${process.env.REACT_APP_API_URL}general/parametrosGeneralesConsulta/0/`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
                .then((res) => res.json())
                .then((data) => {
                    setParametros(data);
                    originalParametros.current = JSON.parse(JSON.stringify(data)); // Guarda copia original
                })
                .catch((err) => {
                    console.error("Error al consultar parámetros generales:", err);
                });
        } else {
            setParametros([]);
            originalParametros.current = [];
        }
    };

    const handleInputChange = (index, field, value) => {
        const nuevosParametros = [...parametros];
        nuevosParametros[index][field] = value;
        setParametros(nuevosParametros);
    };

    // Solo envía los parámetros que han cambiado
    const handleGuardarTodo = () => {
        const cambios = parametros.filter((param, idx) => {
            const original = originalParametros.current[idx];
            return JSON.stringify(param) !== JSON.stringify(original);
        });

        if (cambios.length === 0) {
            alert("No hay cambios para guardar.");
            return;
        }

    fetch(
      `${process.env.REACT_APP_API_URL}general/parametrosGeneralesConsulta/${grupoSeleccionado}/`,
      {
            method: "PUT",
            headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
            },
        body: JSON.stringify(cambios),
      }
    )
            .then((res) => res.json())
            .then((data) => {
                setShowSuccess(true);
                setTimeout(() => setShowSuccess(false), 2500);
                handleChangeGrupo({ target: { value: grupoSeleccionado } });
            })
            .catch((err) => {
                console.error("Error al actualizar parámetros:", err);
            });
    };

    // Nuevo parámetro
    const handleNuevoChange = (field, value) => {
        setNuevoParametro({ ...nuevoParametro, [field]: value });
    };

    // ...existing code...
    const handleCrearParametro = () => {
        if (!nuevoParametro.grupo || !nuevoParametro.parametro) {
            alert("Grupo y parámetro son obligatorios.");
            return;
        }
        // Forzar disp_varchar2 a "0" en el POST
        const parametroParaCrear = {
            ...nuevoParametro,
      disp_varchar2: "",
        };
    fetch(
      `${process.env.REACT_APP_API_URL}general/parametrosGeneralesConsulta/${grupoSeleccionado}/`,
      {
            method: "POST",
            headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
            },
        body: JSON.stringify(parametroParaCrear),
      }
    )
            .then((res) => res.json())
            .then((data) => {
                setShowSuccess(true);
                setTimeout(() => setShowSuccess(false), 2500);
                setNuevoParametro({
                    idparametrosgenerales: 0,
                    grupo: "",
                    parametro: "",
                    vlrmetrica: "",
                    vlrnumericometrica1: "",
                    vlrnumericometrica2: "",
                    vlrmetrica2: "",
                    estado: false,
                    disp_numerico1: "",
                    disp_varchar1: "",
                    disp_varchar2: ""
                });
                handleChangeGrupo({ target: { value: grupoSeleccionado } }); // refresca la lista
            })
            .catch((err) => {
                console.error("Error al crear parámetro:", err);
            });

    };

    return (
        <div>
            <h1>Parámetros Generales</h1>
            <Row className="mb-3" style={{ alignItems: "center" }}>
                <Col sm={4} xs={12}>
                    <label className="form-label" style={{ fontSize: "1.3rem", fontWeight: "bold" }}>
                        Seleccione el grupo a consultar
                    </label>
                </Col>
                <Col sm={4} xs={12}>
                    <select
                        className="form-control"
                        style={{ fontSize: "1.2rem" }}
                        value={grupoSeleccionado}
                        onChange={handleChangeGrupo}
                        title={grupoSeleccionado}
                    >
                        <option value="">Seleccione...</option>
                        {opcionesGrupos.map((grupo) => (
                            <option key={grupo.value} value={grupo.value}>
                                {grupo.label}
                            </option>
                        ))}
                    </select>
                </Col>
                <Col sm={4} xs={12} className="text-end">
                    <Button
                        variant="success"
                        size="lg"
                        onClick={handleGuardarTodo}
                        style={{ fontSize: "1.2rem", minWidth: "140px" }}
                    >
                        Guardar
                    </Button>
                </Col>
            </Row>
            {showSuccess && (
                <Alert variant="success" style={{
                    fontSize: "1.3rem",
                    fontWeight: "bold",
                    background: "#d4edda",
                    color: "#155724",
                    border: "2px solid #c3e6cb",
                    borderRadius: "8px",
                    textAlign: "center"
                }}>
                    ¡Guardado exitoso!
                </Alert>
            )}
            <Row className="mb-3" style={{ background: "#e9f7ef", padding: "16px", borderRadius: "8px", alignItems: "center" }}>
                <Col sm={2}>
                    <select
                        className="form-control"
                        style={{ fontSize: "1.1rem" }}
                        value={nuevoParametro.grupo}
                        onChange={e => handleNuevoChange("grupo", e.target.value)}
                        title={nuevoParametro.grupo}
                    >
                        <option value="">Grupo...</option>
                        {opcionesGrupos.map((grupo) => (
                            <option key={grupo.value} value={grupo.value}>
                                {grupo.label}
                            </option>
                        ))}
                    </select>
                </Col>
                <Col sm={2}>
                    <input
                        type="text"
                        className="form-control"
                        style={{ fontSize: "1.1rem" }}
                        placeholder="Parámetro"
                        value={nuevoParametro.parametro}
                        onChange={e => handleNuevoChange("parametro", e.target.value)}
                        title={nuevoParametro.parametro}
                    />
                </Col>
                <Col sm={2}>
                    <input
                        type="text"
                        className="form-control"
                        style={{ fontSize: "1.1rem" }}
                        placeholder="Valor Métrica"
                        value={nuevoParametro.vlrmetrica}
                        onChange={e => handleNuevoChange("vlrmetrica", e.target.value)}
                        title={nuevoParametro.vlrmetrica}
                    />
                </Col>
                <Col sm={1}>
                    <input
                        type="text"
                        className="form-control"
                        style={{ fontSize: "1.1rem" }}
                        placeholder="Numérico 1"
                        value={nuevoParametro.vlrnumericometrica1}
                        onChange={e => handleNuevoChange("vlrnumericometrica1", e.target.value)}
                        title={nuevoParametro.vlrnumericometrica1}
                    />
                </Col>
                <Col sm={1}>
                    <input
                        type="text"
                        className="form-control"
                        style={{ fontSize: "1.1rem" }}
                        placeholder="Numérico 2"
                        value={nuevoParametro.vlrnumericometrica2}
                        onChange={e => handleNuevoChange("vlrnumericometrica2", e.target.value)}
                        title={nuevoParametro.vlrnumericometrica2}
                    />
                </Col>
                <Col sm={1}>
                    <input
                        type="text"
                        className="form-control"
                        style={{ fontSize: "1.1rem" }}
                        placeholder="Métrica 2"
                        value={nuevoParametro.vlrmetrica2}
                        onChange={e => handleNuevoChange("vlrmetrica2", e.target.value)}
                        title={nuevoParametro.vlrmetrica2}
                    />
                </Col>
                <Col sm={1} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <input
                        type="checkbox"
                        checked={nuevoParametro.estado}
                        onChange={e => handleNuevoChange("estado", e.target.checked)}
                        style={{ width: "18px", height: "18px", marginTop: "2px" }}
                        title={nuevoParametro.estado ? "Activo" : "Inactivo"}
                    />
                </Col>
                <Col sm={1}>
                    <input
                        type="text"
                        className="form-control"
                        style={{ fontSize: "1.1rem" }}
                        placeholder="Disp Numérico 1"
                        value={nuevoParametro.disp_numerico1}
                        onChange={e => handleNuevoChange("disp_numerico1", e.target.value)}
                        title={nuevoParametro.disp_numerico1}
                    />
                </Col>
                <Col sm={1}>
                    <input
                        type="text"
                        className="form-control"
                        style={{ fontSize: "1.1rem" }}
                        placeholder="Disp Varchar 1"
                        value={nuevoParametro.disp_varchar1}
                        onChange={e => handleNuevoChange("disp_varchar1", e.target.value)}
                        title={nuevoParametro.disp_varchar1}
                    />
                </Col>
                <Col sm={2} className="text-end">
                    <Button
                        variant="primary"
                        size="md"
                        onClick={handleCrearParametro}
                        style={{ fontSize: "1.1rem", minWidth: "100px" }}
                    >
                        Crear
                    </Button>
                </Col>
            </Row>
            <hr />
            {parametros.length > 0 && (
                <div>
                    <Row className="mb-2 font-weight-bold" style={{ background: "#f0f0f0", fontSize: "1.1rem" }}>
                        <Col>ID</Col>
                        <Col>Parámetro</Col>
                        <Col>Valor Métrica</Col>
                        <Col>Valor Numérico 1</Col>
                        <Col>Valor Numérico 2</Col>
                        <Col>Valor Métrica 2</Col>
                        <Col>Estado</Col>
                        <Col>Disp Numérico 1</Col>
                        <Col>Disp Varchar 1</Col>
                        <Col>Disp Varchar 2</Col>
                    </Row>
                    {parametros.map((parametro, idx) => (
                        <Row key={parametro.idparametrosgenerales} className="mb-2" style={{ fontSize: "1.1rem" }}>
                            <Col>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "1.1rem" }}
                                    value={parametro.idparametrosgenerales}
                                    disabled
                                    title={parametro.idparametrosgenerales}
                                />
                            </Col>
                            <Col>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "1.1rem" }}
                                    value={parametro.parametro}
                                    onChange={e => handleInputChange(idx, "parametro", e.target.value)}
                                    title={parametro.parametro}
                                />
                            </Col>
                            <Col>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "1.1rem" }}
                                    value={parametro.vlrmetrica}
                                    onChange={e => handleInputChange(idx, "vlrmetrica", e.target.value)}
                                    title={parametro.vlrmetrica}
                                />
                            </Col>
                            <Col>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "1.1rem" }}
                                    value={parametro.vlrnumericometrica1}
                                    onChange={e => handleInputChange(idx, "vlrnumericometrica1", e.target.value)}
                                    title={parametro.vlrnumericometrica1}
                                />
                            </Col>
                            <Col>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "1.1rem" }}
                                    value={parametro.vlrnumericometrica2}
                                    onChange={e => handleInputChange(idx, "vlrnumericometrica2", e.target.value)}
                                    title={parametro.vlrnumericometrica2}
                                />
                            </Col>
                            <Col>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "1.1rem" }}
                                    value={parametro.vlrmetrica2}
                                    onChange={e => handleInputChange(idx, "vlrmetrica2", e.target.value)}
                                    title={parametro.vlrmetrica2}
                                />
                            </Col>
                            <Col>
                                <input
                                    type="checkbox"
                                    checked={parametro.estado}
                                    onChange={e => handleInputChange(idx, "estado", e.target.checked)}
                                    style={{ width: "18px", height: "18px", marginTop: "2px" }}
                                    title={parametro.estado ? "Activo" : "Inactivo"}
                                />
                            </Col>
                            <Col>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "1.1rem" }}
                                    value={parametro.disp_numerico1 || ""}
                                    onChange={e => handleInputChange(idx, "disp_numerico1", e.target.value)}
                                    title={parametro.disp_numerico1}
                                />
                            </Col>
                            <Col>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "1.1rem" }}
                                    value={parametro.disp_varchar1 || ""}
                                    onChange={e => handleInputChange(idx, "disp_varchar1", e.target.value)}
                                    title={parametro.disp_varchar1}
                                />
                            </Col>
                            <Col>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "1.1rem" }}
                                    value={parametro.disp_varchar2 || ""}
                                    onChange={e => handleInputChange(idx, "disp_varchar2", e.target.value)}
                                    title={parametro.disp_varchar2}
                                />
                            </Col>
                        </Row>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ParametrosGenerales;